import {
  FETCH_PBI_ERROR,
  FETCH_PBI_INIT,
  FETCH_PBI_SUCCESS,
} from 'containers/Player/actions/pbi/constants';
import { CLEAR_PLAYER_DATA } from '../actions/player/constants';

const initialState = {
  loading: null,
  data: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PBI_INIT:
      return { ...state, loading: true, data: null, error: null };
    case FETCH_PBI_SUCCESS:
      return { ...state, loading: false, data: action.data, error: null };
    case FETCH_PBI_ERROR:
      return { ...state, loading: false, data: null, error: action.error };
    case CLEAR_PLAYER_DATA:
      return initialState;
    default:
      return state;
  }
};
